import ContentLoader from 'react-content-loader';

const OrderTableLoader = (props: any) => (
  <div className="space-y-4">
    {/* Header skeleton */}
    <div className="flex items-center justify-between mb-5 md:mb-10">
      <ContentLoader
        speed={2}
        width={200}
        height={24}
        viewBox="0 0 200 24"
        backgroundColor="#F3F6FA"
        foregroundColor="#E7ECF3"
        className="w-full"
        {...props}
      >
        <rect x="0" y="0" rx="3" ry="3" width="150" height="24" />
      </ContentLoader>
      <ContentLoader
        speed={2}
        width={300}
        height={46}
        viewBox="0 0 300 46"
        backgroundColor="#F3F6FA"
        foregroundColor="#E7ECF3"
        className="w-full"
        {...props}
      >
        <rect x="0" y="0" rx="6" ry="6" width="300" height="46" />
      </ContentLoader>
    </div>

    {/* Table skeleton */}
    <div className="overflow-x-auto">
      <div className="min-w-[750px]">
        {/* Table header */}
        <div className="bg-[#f3f6f9] rounded-t-md">
          <div className="grid grid-cols-4 gap-4 p-4">
            <ContentLoader
              speed={2}
              width={140}
              height={20}
              viewBox="0 0 140 20"
              backgroundColor="#E7ECF3"
              foregroundColor="#F3F6FA"
              {...props}
            >
              <rect x="0" y="0" rx="3" ry="3" width="140" height="20" />
            </ContentLoader>
            <ContentLoader
              speed={2}
              width={140}
              height={20}
              viewBox="0 0 140 20"
              backgroundColor="#E7ECF3"
              foregroundColor="#F3F6FA"
              {...props}
            >
              <rect x="0" y="0" rx="3" ry="3" width="140" height="20" />
            </ContentLoader>
            <ContentLoader
              speed={2}
              width={130}
              height={20}
              viewBox="0 0 130 20"
              backgroundColor="#E7ECF3"
              foregroundColor="#F3F6FA"
              {...props}
            >
              <rect x="0" y="0" rx="3" ry="3" width="130" height="20" />
            </ContentLoader>
            <ContentLoader
              speed={2}
              width={80}
              height={20}
              viewBox="0 0 80 20"
              backgroundColor="#E7ECF3"
              foregroundColor="#F3F6FA"
              {...props}
            >
              <rect x="0" y="0" rx="3" ry="3" width="80" height="20" />
            </ContentLoader>
          </div>
        </div>

        {/* Table rows */}
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className="border-b border-gray-100">
            <div className="grid grid-cols-4 gap-4 p-4">
              <ContentLoader
                speed={2}
                width={140}
                height={16}
                viewBox="0 0 140 16"
                backgroundColor="#F3F6FA"
                foregroundColor="#E7ECF3"
                {...props}
              >
                <rect x="0" y="0" rx="3" ry="3" width="140" height="16" />
              </ContentLoader>
              <ContentLoader
                speed={2}
                width={140}
                height={16}
                viewBox="0 0 140 16"
                backgroundColor="#F3F6FA"
                foregroundColor="#E7ECF3"
                {...props}
              >
                <rect x="0" y="0" rx="3" ry="3" width="140" height="16" />
              </ContentLoader>
              <ContentLoader
                speed={2}
                width={130}
                height={16}
                viewBox="0 0 130 16"
                backgroundColor="#F3F6FA"
                foregroundColor="#E7ECF3"
                {...props}
              >
                <rect x="0" y="0" rx="3" ry="3" width="130" height="16" />
              </ContentLoader>
              <ContentLoader
                speed={2}
                width={80}
                height={16}
                viewBox="0 0 80 16"
                backgroundColor="#F3F6FA"
                foregroundColor="#E7ECF3"
                {...props}
              >
                <rect x="0" y="0" rx="3" ry="3" width="80" height="16" />
              </ContentLoader>
            </div>
          </div>
        ))}
      </div>
    </div>

    {/* Pagination skeleton */}
    <div className="mt-5 flex justify-end">
      <ContentLoader
        speed={2}
        width={200}
        height={32}
        viewBox="0 0 200 32"
        backgroundColor="#F3F6FA"
        foregroundColor="#E7ECF3"
        {...props}
      >
        <rect x="0" y="0" rx="6" ry="6" width="200" height="32" />
      </ContentLoader>
    </div>
  </div>
);

export default OrderTableLoader;
